/**
 * The OrangePi FAMILY, in one place.
 *
 * Bench 2026-10-19: a freshly claimed OrangePi PC (OPC-…, xunlong,orangepi-pc)
 * showed "Waiting for your NodeMCU to power on" while an OrangePi One never
 * does — the dashboard keyed on the ONE (its target, its ORP- prefix) instead
 * of on "any OrangePi". Every screen that treats the One specially — on-board
 * coin reader so no NodeMCU, no radio of its own, hosts VLAN sub-vendos, SD
 * card image — must treat the PC (Allwinner H3 too) and the Zero 3 (H618) the
 * same way. Decide it HERE, never with a literal in a component.
 */

/** Firmware / catalog targets of the SD-card boards. */
export const ORANGEPI_TARGETS = ['orangepi', 'orangepi-pc', 'orangepi-zero3'] as const;
export type OrangePiTarget = (typeof ORANGEPI_TARGETS)[number];

/** The board_name the agent reports: xunlong,orangepi-one / -pc / -zero3
 *  (older agents reported a bare 'orangepi-one'). */
export const isOrangePiBoard = (hwBoard?: string | null): boolean =>
   /orangepi|xunlong/i.test(hwBoard || '');

export const isOrangePiTarget = (target?: string | null): boolean =>
   (ORANGEPI_TARGETS as readonly string[]).includes(target || '');

/** Device-id prefixes the server hands the family: ORP- (One), OPC- (PC), OZ3- (Zero 3). */
export const isOrangePiDeviceId = (deviceId?: string | null): boolean =>
   /^(ORP|OPC|OZ3)-/i.test(deviceId || '');
